export const QR_CODE_HRA_RECEPCAO_MAP: { [key: number]: string } = {
  22: 'qrcode-hra-marisacare_Fatima_22.png',
  103: 'qrcode-hra-marisacare_Centro_103.png',
  241: 'qrcode-hra-marisacare_Boa_Vista_241.png',
  272: 'qrcode-hra-marisacare_ViaSul_272.png',
  273: 'qrcode-hra-marisacare_Messejana_273.png',
  274: 'qrcode-hra-marisacare_North_Shopping_274.png',
  276: 'qrcode-hra-marisacare_Maraponga_276.png',
  277: 'qrcode-hra-marisacare_Itaperi_277.png',
  279: 'qrcode-hra-marisacare_Prazeres_279.png',
  280: 'qrcode-hra-marisacare_Tacaruna_280.png',
  627: 'qrcode-hra-marisacare_RioMar_Fortaleza_627.png',
  1001: 'qrcode-hra-marisacare_RioMar_Recife_1001.png',
  1002: 'qrcode-hra-marisacare_Guararapes_1002.png',
  1004: 'qrcode-hra-marisacare_Lapa_1004.png',
  1005: 'qrcode-hra-marisacare_Fatima_II_1005.png',
  1007: 'qrcode-hra-marisacare_Joquei_1007.png',
  1009: 'qrcode-hra-marisacare_Maraponga_1009.png',
};
